/* Sui Story — GSAP / ScrollTrigger choreography.
   initAnimations(scope) is idempotent and re-runnable per Barba container.
   All page-content triggers carry an id starting 'ss-' so they can be cleanly
   killed and rebuilt on navigation. Header/footer do NOT use ScrollTrigger. */
(function () {
  var S = (window.SuiStory = window.SuiStory || {});

  // GSAP-side mirror of the DESIGN.md ease library.
  S.EASES = { enter: 'power3.out', exit: 'power2.in', embroidery: 'power2.inOut', hover: 'power2.out', parallax: 'none' };

  function showStatic(scope) {
    scope.querySelectorAll('[data-reveal], [data-reveal-item]').forEach(function (el) {
      el.style.opacity = '1';
      el.style.transform = 'none';
    });
    scope.querySelectorAll('[data-embroidery]').forEach(function (el) {
      if (S.drawEmbroidery) S.drawEmbroidery(el);
    });
  }

  function killOurTriggers() {
    if (!window.ScrollTrigger) return;
    ScrollTrigger.getAll().forEach(function (t) {
      if (t.vars && typeof t.vars.id === 'string' && t.vars.id.indexOf('ss-') === 0) t.kill();
    });
  }

  S.initAnimations = function (scope) {
    scope = scope || document;
    var enabled = window.gsap && window.ScrollTrigger &&
                  !S.reduceMotion() &&
                  document.documentElement.classList.contains('js');

    if (!enabled) { showStatic(scope); return; }

    killOurTriggers();

    // 1. Single staggered fade-up reveals
    scope.querySelectorAll('[data-reveal]').forEach(function (el) {
      var delay = parseFloat(el.dataset.revealDelay || 0);
      gsap.fromTo(el, { y: 40, opacity: 0 }, {
        y: 0, opacity: 1, duration: 0.8, ease: S.EASES.enter, delay: delay,
        scrollTrigger: { id: 'ss-reveal', trigger: el, start: 'top 85%', once: true }
      });
    });

    // 2. Grouped flowing-wave reveals: [data-reveal-group] > [data-reveal-item]
    scope.querySelectorAll('[data-reveal-group]').forEach(function (group) {
      var items = group.querySelectorAll('[data-reveal-item]');
      if (!items.length) return;
      gsap.fromTo(items, { y: 56, opacity: 0, scale: 0.97 }, {
        y: 0, opacity: 1, scale: 1, duration: 0.7, ease: S.EASES.enter, stagger: 0.08,
        scrollTrigger: { id: 'ss-group', trigger: group, start: 'top 80%', once: true }
      });
    });

    // 3. Parallax: [data-parallax] (number = strength %)
    scope.querySelectorAll('[data-parallax]').forEach(function (el) {
      var amt = parseFloat(el.dataset.parallax || 12);
      gsap.to(el, {
        yPercent: -amt, ease: 'none',
        scrollTrigger: {
          id: 'ss-parallax',
          trigger: el.closest('[data-parallax-scope]') || el,
          start: 'top bottom', end: 'bottom top', scrub: 1.2
        }
      });
    });

    // 4. Count-up numbers: [data-count] (target value)
    scope.querySelectorAll('[data-count]').forEach(function (el) {
      var target = parseFloat(el.dataset.count);
      var prefix = el.dataset.countPrefix || '';
      var suffix = el.dataset.countSuffix || '';
      var state = { v: parseFloat(el.dataset.countFrom || 0) };
      gsap.to(state, {
        v: target, duration: 1.6, ease: 'power2.out',
        scrollTrigger: { id: 'ss-count', trigger: el, start: 'top 88%', once: true },
        onUpdate: function () { el.textContent = prefix + Math.round(state.v) + suffix; }
      });
    });

    // 5. Drawing thread line: [data-draw-line] (an SVG path)
    scope.querySelectorAll('[data-draw-line]').forEach(function (path) {
      try {
        var len = path.getTotalLength();
        gsap.set(path, { strokeDasharray: len, strokeDashoffset: len });
        gsap.to(path, {
          strokeDashoffset: 0, ease: 'none',
          scrollTrigger: {
            id: 'ss-line',
            trigger: path.closest('[data-draw-scope]') || path,
            start: 'top 75%', end: 'bottom 65%', scrub: 1
          }
        });
      } catch (e) {}
    });

    // 6. Embroidered headlines — stitch each letter in. Onload headlines (hero)
    //    draw immediately; the rest draw when scrolled into view.
    scope.querySelectorAll('[data-embroidery][data-embroidery-onload]').forEach(function (el) {
      if (S.drawEmbroidery) S.drawEmbroidery(el);
    });
    scope.querySelectorAll('[data-embroidery]:not([data-embroidery-onload])').forEach(function (el) {
      ScrollTrigger.create({
        id: 'ss-embro', trigger: el, start: 'top 82%', once: true,
        onEnter: function () { if (S.drawEmbroidery) S.drawEmbroidery(el); }
      });
    });

    ScrollTrigger.refresh();

    // Fail-safe: anything already within the viewport must never stay invisible.
    // Guards against any measurement/timing edge case (especially right after a
    // Barba swap) leaving [data-reveal] content frozen at opacity:0.
    if (S._revealFailsafe) clearTimeout(S._revealFailsafe);
    S._revealFailsafe = setTimeout(function () {
      var vh = window.innerHeight || document.documentElement.clientHeight;
      var inView = function (el) { var r = el.getBoundingClientRect(); return r.top < vh * 0.95 && r.bottom > 0; };
      scope.querySelectorAll('[data-reveal], [data-reveal-item]').forEach(function (el) {
        if (inView(el) && parseFloat(getComputedStyle(el).opacity) < 0.05) {
          gsap.to(el, { opacity: 1, y: 0, scale: 1, duration: 0.5, ease: S.EASES.enter, overwrite: 'auto' });
        }
      });
      // Any headline on-screen but not yet stitched gets drawn now.
      scope.querySelectorAll('[data-embroidery]:not(.is-drawn)').forEach(function (el) {
        if (inView(el) && S.drawEmbroidery) S.drawEmbroidery(el);
      });
    }, 400);

    // Persistent safety net: even if a ScrollTrigger reveal is missed (stale
    // positions after late-loading images), force any [data-reveal] / [data-reveal-item]
    // to become visible the moment it scrolls into view. Fires slightly later than
    // the ScrollTrigger so a normal reveal animation isn't cut short; only genuinely
    // stuck (opacity ~0) elements are forced.
    if (window.IntersectionObserver) {
      if (S._revealIO) S._revealIO.disconnect();
      S._revealIO = new IntersectionObserver(function (entries, obs) {
        entries.forEach(function (en) {
          if (!en.isIntersecting) return;
          var rel = en.target;
          if (parseFloat(getComputedStyle(rel).opacity) < 0.05) {
            gsap.to(rel, { opacity: 1, y: 0, scale: 1, duration: 0.5, ease: S.EASES.enter, overwrite: 'auto' });
          }
          obs.unobserve(rel);
        });
      }, { rootMargin: '0px 0px -20% 0px', threshold: 0.01 });
      scope.querySelectorAll('[data-reveal], [data-reveal-item]').forEach(function (rel) { S._revealIO.observe(rel); });
    }
  };
})();
